import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <motion.footer
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="py-10 w-[100%] bg-white rounded-b-[30px]"
        >
            <motion.div
                className="container mx-auto flex justify-between items-start gap-8 md:px-4 px-1 md:w-[70%] xsm:w-[100%]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.6 }}
            >
                {/* Features Column */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.6 }}>
                        <h4 className="font-sans text-[18.15px] font-semibold leading-[16.55px] tracking-[0.528px] text-left space-y-2 mb-2 decoration-skip-ink-none">
                            Quick Links:
                        </h4>
                        <ul className="space-y-2">
                            <li className='font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none'>
                                <Link to="/">
                                    Home
                                </Link>
                            </li>
                            <li className='font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none'>
                                <Link to="/about">
                                    About Us
                                </Link>
                            </li>
                            <li className='font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none'>
                                <Link to="/service">
                                    Services
                                </Link>
                            </li>
                            <li className='font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none'>
                                <Link to="/contact-us">
                                    Contact Us
                                </Link>
                            </li>
                            <li className='font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none'>
                                <Link to="/privacy-policy">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li className='font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none'>
                                <Link to="/terms-condition">
                                    Terms & Conditions
                                </Link>
                            </li>
                        </ul>
                    </motion.div>
                </motion.div>

                {/* Resources Column */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}>
                    <h4 className="font-sans text-[18.15px] font-semibold leading-[16.55px] tracking-[0.528px] text-left space-y-2 mb-2 decoration-skip-ink-none">
                        Contact Information:
                    </h4>
                    <ul className="space-y-2">
                        <li className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none">
                            Phone: +918726271114
                        </li>
                        <li className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none">
                            Email: support@qbusrentals.com
                        </li>
                        <li className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818]   decoration-skip-ink-none">
                            Address: Qbus Rentals, D-9, Ground floor, sector-3, Noida Gautam Buddha Nagar, Noida 201301.
                        </li>
                    </ul>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}>
                    <h4 className="font-sans text-[18.15px] font-semibold leading-[16.55px] tracking-[0.528px] text-left mb-2 space-y-2  decoration-skip-ink-none">
                        Social Media Links:
                    </h4>
                    <ul className="space-y-2">
                        <a
                            href="https://www.facebook.com/share/1KDUF53oZ7/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818] hover:underline"
                        >
                            <li className='mb-2'>Facebook</li>
                        </a>

                        <a
                            href="https://www.instagram.com/qbus_official?igsh=ZGFwYm1pNHhza3lo"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818] hover:underline mb-2"
                        >
                            <li className='mb-2'>Instagram</li>
                        </a>

                        <a
                            href="https://youtube.com/@qbusofficial?si=GIlCmNyOcjh_Ry4_"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818] hover:underline"
                        >
                            <li className='mb-2'> YouTube</li>
                        </a>

                        <a
                            href="https://www.linkedin.com/company/qbus-rentals/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-sans text-[14.65px] font-normal leading-[15.45px] text-left text-[#181818] hover:underline"
                        >
                            <li className='mb-2'>LinkedIn</li>
                        </a>
                    </ul>

                </motion.div>
            </motion.div>
            <div className="font-sans mt-5 text-[11.65px] font-normal leading-[15.45px] text-left flex justify-between decoration-skip-ink-none w-[70%] mx-auto text-gray-600">
                © 2024 Qbus. All Rights Reserved.
                <span>
                    Managed by - ANSHULA TIWARI
                </span>
            </div>
            <p>	</p>
        </motion.footer>
    );
};

export default Footer;
